import React from "react";
import { useQuiz } from "src/contexts/QuizContext.js";
import { quizInteractionTracking } from "src/modules/QuizHelpers/index.js";

function QuizButtonBack() {
    const {
        quizStatus,
        questionNo,
        questionSection,
        dispatch,
        windowWidth,
        questions,
    } = useQuiz();

    const getCurrentAnswerIndex = () => {
        if (!questionNo || !questionSection) return null;
        const qKey = `question${questionNo}`;
        const sKey = `section${questionSection}`;
        const question = questions[qKey];
        if (!question) return null;

        const subquestion = question.subquestions?.[sKey];
        if (!subquestion) return null;

        const currentAnswer =
            subquestion.currentAnswer || subquestion.savedAnswer;
        if (!currentAnswer) return null;

        const options = subquestion.options || [];
        const index = options.findIndex((opt) => opt === currentAnswer);
        return index >= 0 ? index + 1 : null; // 1-based index
    };

    // toggle handle back
    function handleBackButton(e) {
        e.preventDefault();

        // Get the actual current question number from the question key
        // Verify the question exists - if not, use questionNo - 1
        let actualQuestionNo = questionNo;
        let qKey = `question${questionNo}`;
        if (!questions[qKey] && questionNo > 1) {
            actualQuestionNo = questionNo - 1;
            qKey = `question${actualQuestionNo}`;
        }
        // Derive question number from the key (e.g., "question3" -> "Q3")
        const questionNumber = qKey.replace("question", "Q");

        // Click "Go back" to the previous question
        quizInteractionTracking({
            interaction_type: "click",
            question_number: questionNumber,
            sub_question_index: questionSection || null,
            selected_answer_index: getCurrentAnswerIndex(),
            answer_changed: false,
            navigation_action: "back",
        });

        dispatch({
            type: "quizStatus",
            payload: {
                value: quizStatus == "summary" ? "progress" : "summary",
                snapshot: {
                    questionNo,
                    questionSection,
                },
            },
        });
    }

    return questionNo > 1 ? (
        <div className="quiz-main__back-container">
            <button
                className="quiz-main__back-button"
                onClick={handleBackButton}
                aria-label="Go back to previous question"
            >
                {windowWidth > 1024
                    ? `Go back to previous question`
                    : `Go back`}
            </button>
        </div>
    ) : null;
}

export default QuizButtonBack;
